export enum ConversionType {
  PageView = 'pageView',
  ViewContent = 'viewContent',
  InitiateCheckout = 'initiateCheckout',
  Purchase = 'purchase',
  AddToCart = 'addToCart',
  CompleteRegistration = 'completeRegistration',
}
